<template lang="pug">
v-progress-circular(:width="6" :size="size" color="#BABABA" indeterminate)
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 60,
    },
  },
};
</script>
